/**
 * Mapping look this https://docs.google.com/spreadsheets/d/11S4YDDkHJQdktTAepL3_6ma3-BhYH8daekHjb5pEb0I/
 */

(function (w, d) {
	if (w.location.pathname !== '/payment-methods.html') return;
	const regionsNode = d.querySelector('.js-regions');
	const countriesNode = d.querySelector('.js-countries');
	const industriesNode = d.querySelector('.js-industries');
	const paymentsNode = d.querySelector('.js-payments');
	const form = d.querySelector('.form-wrapper_payment-methods');

	const regions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

	let selectedRegion = 0;
	let selectedCountryId = 0;
	let selectedIndustry = 0;

	const regionsList = {
		1: {name: 'LATAM', countries: [20, 3, 14, 18, 30, 32, 44, 112, 113, 114, 151, 154]},
		2: {name: 'Africa', countries: [1, 2, 15, 19, 22, 23, 25, 27, 28, 29, 33, 34, 36, 45, 47, 49, 52, 55, 56, 59, 63, 64, 77, 82, 87, 89, 92, 93, 98, 99, 100, 107, 108, 120, 123, 125, 127, 129, 130, 134, 135, 138, 142, 144, 145, 147, 156, 157]},
		3: {name: 'Asia', countries: [10, 17, 24, 31, 66, 69, 70, 72, 74, 78, 81, 86, 88, 101, 111, 115, 131, 137, 141, 143, 146, 155]},
		4: {name: 'Australia', countries: [5, 105]},
		5: {name: 'CA', countries: [8, 11, 14, 16, 35, 38, 42, 43, 46, 62, 65, 75, 95, 106, 112, 118]},
		6: {name: 'CIS', countries: [4, 7, 12, 57, 96, 122, 148, 153, 76]},
		7: {name: 'EU', countries: [6, 13, 21, 37, 39, 40, 41, 48, 50, 51, 58, 60, 67, 68, 71, 73, 80, 83, 84, 85, 90, 97, 102, 109, 116, 117, 121, 124, 128, 132, 136, 139, 140, 150, 133]},
		8: {name: 'GCC', countries: [9, 79, 110, 119, 126, 149]},
		9: {name: 'Overseas', countries: [53, 54, 61, 91, 94, 103, 104, 120]},
		10: {name: 'North America', countries: [152, 26]},
	};
	const countriesList = {
		1: {name: 'Algeria', ISO2: 'DZ', industries: [3, 6, 7]},
		2: {name: 'Angola', ISO2: 'AO', industries: [3, 6, 7]},
		3: {name: 'Argentina', ISO2: 'AR', industries: [3, 6, 7]},
		4: {name: 'Armenia', ISO2: 'AM', industries: [3, 6, 7]},
		5: {name: 'Australia', ISO2: 'AU', industries: [3, 6, 7]},
		6: {name: 'Austria', ISO2: 'AT', industries: [3, 5, 6, 7]},
		7: {name: 'Azerbaijan', ISO2: 'AZ', industries: [3, 6, 7]},
		8: {name: 'Bahamas', ISO2: 'BS', industries: [3, 6, 7]},
		9: {name: 'Bahrain', ISO2: 'BH', industries: [3, 6, 7]},
		10: {name: 'Bangladesh', ISO2: 'BD', industries: [3, 6, 7]},
		11: {name: 'Barbados', ISO2: 'BB', industries: [3, 6, 7]},
		12: {name: 'Belarus', ISO2: 'BY', industries: [3, 6, 7]},
		13: {name: 'Belgium', ISO2: 'BE', industries: [3, 6, 7]},
		14: {name: 'Belize', ISO2: 'BZ', industries: [3, 6, 7]},
		15: {name: 'Benin', ISO2: 'BJ', industries: [3, 6, 7]},
		16: {name: 'Bermuda', ISO2: 'BM', industries: [3, 6, 7]},
		17: {name: 'Bhutan', ISO2: 'BT', industries: [3, 6, 7]},
		18: {name: 'Bolivia', ISO2: 'BO', industries: [3, 6, 7]},
		19: {name: 'Botswana', ISO2: 'BW', industries: [3, 6, 7]},
		20: {name: 'Brazil', ISO2: 'BR', industries: [3, 5, 6, 7]},
		21: {name: 'Bulgaria', ISO2: 'BG', industries: [3, 5, 6, 7]},
		22: {name: 'Burkina Faso', ISO2: 'BF', industries: [3, 6, 7]},
		23: {name: 'Burundi', ISO2: 'BI', industries: [3, 6, 7]},
		24: {name: 'Cambodia', ISO2: 'KH', industries: [3, 6, 7]},
		25: {name: 'Cameroon', ISO2: 'CM', industries: [3, 6, 7]},
		26: {name: 'Canada', ISO2: 'CA', industries: [3, 6, 7]},
		27: {name: 'Capo Verde', ISO2: 'CV', industries: [3, 6, 7]},
		28: {name: 'Central African Republick', ISO2: 'CF', industries: [3, 6, 7]},
		29: {name: 'Chad', ISO2: 'TD', industries: [3, 6, 7]},
		30: {name: 'Chile', ISO2: 'CL', industries: [3, 6, 7]},
		31: {name: 'China', ISO2: 'CN', industries: [3, 6, 7]},
		32: {name: 'Columbia', ISO2: 'CO', industries: [3, 6, 7]},
		33: {name: 'Comoros', ISO2: 'KM', industries: [3, 6, 7]},
		34: {name: 'Congo', ISO2: 'CD', industries: [3, 6, 7]},
		35: {name: 'Costa Rica', ISO2: 'CR', industries: [3, 6, 7]},
		36: {name: 'Cote dʼIvoire', ISO2: 'CI', industries: [3, 6, 7]},
		37: {name: 'Croatia', ISO2: 'HR', industries: [3, 5, 6, 7]},
		38: {name: 'Curaçao', ISO2: 'CW', industries: [3, 6, 7]},
		39: {name: 'Cyprus', ISO2: 'CY', industries: [3, 6, 7]},
		40: {name: 'Czech Republic', ISO2: 'CZ', industries: [3, 5, 6, 7]},
		41: {name: 'Denmark', ISO2: 'DK', industries: [3, 6, 7]},
		42: {name: 'Dominica', ISO2: 'DM', industries: [3, 6, 7]},
		43: {name: 'Dominican Republic', ISO2: 'DO', industries: [3, 6, 7]},
		44: {name: 'Ecuador', ISO2: 'EC', industries: [3, 6, 7]},
		45: {name: 'Egypt', ISO2: 'EG', industries: [3, 6, 7]},
		46: {name: 'El Salvador', ISO2: 'SV', industries: [3, 6, 7]},
		47: {name: 'Equatorial Guinea', ISO2: 'GQ', industries: [3, 6, 7]},
		48: {name: 'Estonia', ISO2: 'EE', industries: [3, 5, 6, 7]},
		49: {name: 'Ethiopia', ISO2: 'ET', industries: [3, 6, 7]},
		50: {name: 'Finland', ISO2: 'FI', industries: [3, 5, 6, 7]},
		51: {name: 'France', ISO2: 'FR', industries: [3, 5, 6, 7]},
		52: {name: 'French Guiana', ISO2: 'GF', industries: [3, 6, 7]},
		53: {name: 'French Polynesia', ISO2: 'PF', industries: [3, 6, 7]},
		54: {name: 'French Southern Territories ', ISO2: 'TF', industries: [3, 6, 7]},
		55: {name: 'Gabon', ISO2: 'GA', industries: [3, 6, 7]},
		56: {name: 'Gambia', ISO2: 'GM', industries: [3, 6, 7]},
		57: {name: 'Georgia', ISO2: 'GE', industries: [3, 6, 7]},
		58: {name: 'Germany', ISO2: 'DE', industries: [3, 5, 6, 7]},
		59: {name: 'Ghana', ISO2: 'GH', industries: [3, 6, 7]},
		60: {name: 'Greece', ISO2: 'GR', industries: [3, 6, 7]},
		61: {name: 'Guadeloupe', ISO2: 'GP', industries: [3, 6, 7]},
		62: {name: 'Guatemala', ISO2: 'GT', industries: [3, 6, 7]},
		63: {name: 'Guinea', ISO2: 'GN', industries: [3, 6, 7]},
		64: {name: 'Guinea-Bissau', ISO2: 'GW', industries: [3, 6, 7]},
		65: {name: 'Honduras', ISO2: 'HN', industries: [3, 6, 7]},
		66: {name: 'Hong Kong', ISO2: 'HK', industries: [3, 5, 6, 7]},
		67: {name: 'Hungary', ISO2: 'HU', industries: [3, 5, 6, 7]},
		68: {name: 'Iceland', ISO2: 'IS', industries: [3, 6, 7]},
		69: {name: 'India', ISO2: 'IN', industries: [3, 6, 7]},
		70: {name: 'Indonesia', ISO2: 'ID', industries: [3, 6, 7]},
		71: {name: 'Ireland', ISO2: 'IE', industries: [3, 6, 7]},
		72: {name: 'Israel', ISO2: 'IL', industries: [3, 5, 6, 7]},
		73: {name: 'Italy', ISO2: 'IT', industries: [3, 5, 6, 7]},
		74: {name: 'Japan', ISO2: 'JP', industries: [3, 6, 7]},
		75: {name: 'Jamaica', ISO2: 'JM', industries: [3, 6, 7]},
		76: {name: 'KAZAKHSTAN ', ISO2: 'KZ', industries: [3, 5, 6, 7]},
		77: {name: 'Kenya', ISO2: 'KE', industries: [3, 6, 7]},
		78: {name: 'Korea, South', ISO2: 'KR', industries: [3, 6, 7]},
		79: {name: 'Kuwait', ISO2: 'KW', industries: [3, 6, 7]},
		80: {name: 'Latvia', ISO2: 'LV', industries: [3, 5, 6, 7]},
		81: {name: 'Lebanon', ISO2: 'LB', industries: [3, 6, 7]},
		82: {name: 'Lesotho', ISO2: 'LS', industries: [3, 6, 7]},
		83: {name: 'Liechtenstein', ISO2: 'LI', industries: [3, 6, 7]},
		84: {name: 'Lithuania', ISO2: 'LT', industries: [3, 6, 7]},
		85: {name: 'Luxembourg', ISO2: 'LU', industries: [3, 6, 7]},
		86: {name: 'Macao', ISO2: 'MO', industries: [3, 5, 6, 7]},
		87: {name: 'Malawi', ISO2: 'MW', industries: [3, 6, 7]},
		88: {name: 'Malaysia', ISO2: 'MY', industries: [3, 6, 7]},
		89: {name: 'Mali', ISO2: 'ML', industries: [3, 6, 7]},
		90: {name: 'Malta', ISO2: 'MT', industries: [3, 6, 7]},
		91: {name: 'Martinique', ISO2: 'MQ', industries: [3, 6, 7]},
		92: {name: 'Mauritania', ISO2: 'MR', industries: [3, 6, 7]},
		93: {name: 'Mauritius', ISO2: 'MU', industries: [3, 6, 7]},
		94: {name: 'Mayotte', ISO2: 'YT', industries: [3, 6, 7]},
		95: {name: 'Mexico', ISO2: 'MX', industries: [3, 6, 7]},
		96: {name: 'Moldova', ISO2: 'MD', industries: [3, 6, 7]},
		97: {name: 'Monaco', ISO2: 'MC', industries: [3, 6, 7]},
		98: {name: 'Morocco', ISO2: 'MA', industries: [3, 6, 7]},
		99: {name: 'Mozambique', ISO2: 'MZ', industries: [3, 6, 7]},
		100: {name: 'Namibia', ISO2: 'NA', industries: [3, 6, 7]},
		101: {name: 'Nepal', ISO2: 'NP', industries: [3, 6, 7]},
		102: {name: 'Netherlands', ISO2: 'NL', industries: [3, 6, 7]},
		103: {name: 'Netherlands Antilles', ISO2: 'NL', industries: [3, 6, 7]},
		104: {name: 'New Caledonia', ISO2: 'NC', industries: [3, 6, 7]},
		105: {name: 'New Zealand', ISO2: 'NZ', industries: [3, 6, 7]},
		106: {name: 'Nicaragua', ISO2: 'NI', industries: [3, 6, 7]},
		107: {name: 'Niger', ISO2: 'NE', industries: [3, 6, 7]},
		108: {name: 'Nigeria', ISO2: 'NG', industries: [3, 6, 7]},
		109: {name: 'Norway', ISO2: 'NO', industries: [3, 6, 7]},
		110: {name: 'Oman', ISO2: 'OM', industries: [3, 6, 7]},
		111: {name: 'Pakistan', ISO2: 'PK', industries: [3, 6, 7]},
		112: {name: 'Panama', ISO2: 'PA', industries: [3, 6, 7]},
		113: {name: 'Paraguay', ISO2: 'PY', industries: [3, 6, 7]},
		114: {name: 'Peru ', ISO2: 'PE', industries: [3, 6, 7]},
		115: {name: 'Philippines', ISO2: 'PH', industries: [3, 6, 7]},
		116: {name: 'Poland', ISO2: 'PL', industries: [3, 5, 6, 7]},
		117: {name: 'Portugal', ISO2: 'PT', industries: [3, 5, 6, 7]},
		118: {name: 'Puerto Rico', ISO2: 'PR', industries: [3, 6, 7]},
		119: {name: 'Qatar', ISO2: 'QA', industries: [3, 6, 7]},
		120: {name: 'Réunion', ISO2: 'RE', industries: [3, 6, 7]},
		121: {name: 'Romania', ISO2: 'RO', industries: [3, 5, 6, 7]},
		122: {name: 'Russia', ISO2: 'RU', industries: [3, 6, 7]},
		123: {name: 'Rwanda', ISO2: 'RW', industries: [3, 6, 7]},
		124: {name: 'San Marino', ISO2: 'SM', industries: [3, 6, 7]},
		125: {name: 'Sao Tome & Principe', ISO2: 'ST', industries: [3, 6, 7]},
		126: {name: 'Saudi Arabia', ISO2: 'SA', industries: [3, 6, 7]},
		127: {name: 'Senegal', ISO2: 'SN', industries: [3, 6, 7]},
		128: {name: 'Serbia', ISO2: 'RS', industries: [3, 6, 7]},
		129: {name: 'Seychelles', ISO2: 'SC', industries: [3, 6, 7]},
		130: {name: 'Sierra Leone', ISO2: 'SL', industries: [3, 6, 7]},
		131: {name: 'Singapore', ISO2: 'SG', industries: [3, 5, 6, 7]},
		132: {name: 'Slovakia', ISO2: 'SK', industries: [3, 5, 6, 7]},
		133: {name: 'Slovenia', ISO2: 'SI', industries: [3, 5, 6, 7]},
		134: {name: 'Somalia', ISO2: 'SO', industries: [3, 6, 7]},
		135: {name: 'South Africa', ISO2: 'ZA', industries: [3, 6, 7]},
		136: {name: 'Spain', ISO2: 'ES', industries: [3, 5, 6, 7]},
		137: {name: 'Sri Lanka', ISO2: 'LK', industries: [3, 6, 7]},
		138: {name: 'Swaziland', ISO2: 'SZ', industries: [3, 6, 7]},
		139: {name: 'Sweden', ISO2: 'SE', industries: [3, 5, 6, 7]},
		140: {name: 'Switzerland', ISO2: 'CH', industries: [3, 6, 7]},
		141: {name: 'Taiwan', ISO2: 'TW', industries: [3, 6, 7]},
		142: {name: 'Tanzania', ISO2: 'TZ', industries: [3, 6, 7]},
		143: {name: 'Thailand', ISO2: 'TH', industries: [3, 6, 7]},
		144: {name: 'Togo', ISO2: 'TG', industries: [3, 6, 7]},
		145: {name: 'Tunisia', ISO2: 'TN', industries: [3, 6, 7]},
		146: {name: 'Turkey', ISO2: 'TR', industries: [3, 6, 7]},
		147: {name: 'Uganda', ISO2: 'UG', industries: [3, 6, 7]},
		148: {name: 'Ukraine', ISO2: 'UA', industries: [3, 6, 7]},
		149: {name: 'United Arab Emirates', ISO2: 'AE', industries: [3, 5, 6, 7]},
		150: {name: 'United Kingdom', ISO2: 'GB', industries: [3, 6, 7]},
		151: {name: 'Uruguay', ISO2: 'UY', industries: [3, 6, 7]},
		152: {name: 'USA', ISO2: 'US', industries: [3, 6, 7]},
		153: {name: 'Uzbekistan', ISO2: 'UZ', industries: [3, 5, 6, 7]},
		154: {name: 'Venezuela', ISO2: 'VE', industries: [3, 6, 7]},
		155: {name: 'Vietnam', ISO2: 'VN', industries: [3, 6, 7]},
		156: {name: 'Zambia', ISO2: 'ZM', industries: [3, 6, 7]},
		157: {name: 'Zimbabwe', ISO2: 'ZW', industries: [3, 6, 7]},
	};
	const industriesList = {
		1: {name: 'Adult'},
		2: {name: 'Betting'},
		3: {name: 'Dating'},
		4: {name: 'Gambling'},
		5: {name: 'Gaming'},
		6: {name: 'Subscription'},
		7: {name: 'Travel'},
	};
	const paymentsTypes = {
		1: {name: 'Wallet', type: 'wallet'},
		2: {name: 'Prepaid', type: 'prepaid'},
		3: {name: 'Bank Transfer', type: 'bank'},
		4: {name: 'Cash payments / Post-pay', type: 'cash'},
	};
	/**
	 * @type is payment type
	 * @pairs [countryId, industryId][]
	 */
	const paymentsList = [
		{name: 'skrill', type: 1, pairs: [[20, 12], [3, 12], [14, 12], [18, 12], [30, 12], [32, 12], [44, 12], [112, 12], [113, 12], [114, 12], [151, 12], [154, 12], [1, 12], [2, 12], [15, 12], [19, 12], [22, 12], [23, 12], [25, 12], [27, 12], [28, 12], [29, 12], [33, 12], [34, 12], [36, 12], [45, 12], [47, 12], [49, 12], [52, 12], [55, 12], [56, 12], [59, 12], [63, 12], [64, 12], [77, 12], [82, 12], [87, 12], [89, 12], [92, 12], [93, 12], [98, 12], [99, 12], [100, 12], [107, 12], [108, 12], [120, 12], [123, 12], [125, 12], [127, 12], [129, 12], [130, 12], [134, 12], [135, 12], [138, 12], [142, 12], [144, 12], [145, 12], [147, 12], [156, 12], [157, 12], [10, 12], [17, 12], [24, 12], [31, 12], [131, 12], [131, 3], [146, 12], [66, 13], [69, 12], [70, 12], [72, 13], [78, 12], [81, 12], [86, 13], [88, 12], [101, 12], [111, 12], [115, 12], [137, 12], [141, 12], [143, 12], [146, 13], [155, 12], [105, 12], [8, 12], [11, 12], [16, 12], [35, 12], [38, 12], [42, 12], [43, 12], [46, 12], [62, 12], [65, 12], [75, 12], [95, 12], [106, 12], [118, 12], [4, 12], [7, 12], [12, 12], [57, 12], [96, 12], [122, 12], [148, 12], [153, 13], [76, 13], [6, 13], [13, 12], [21, 13], [37, 13], [39, 12], [40, 12], [40, 3], [41, 12], [48, 13], [50, 13], [51, 13], [58, 13], [60, 12], [67, 13], [68, 12], [71, 12], [73, 13], [80, 13], [83, 12], [84, 12], [85, 12], [90, 12], [97, 12], [102, 12], [109, 12], [116, 12], [116, 3], [117, 13], [121, 13], [124, 12], [128, 12], [132, 12], [132, 3], [136, 13], [139, 13], [140, 12], [150, 12], [133, 13], [9, 12], [79, 12], [110, 12], [119, 12], [126, 12], [149, 13], [53, 12], [54, 12], [61, 12], [91, 12], [94, 12], [103, 12], [104, 12], [152, 12], [26, 12]]},
		{name: 'neteller', type: 1, pairs: [[20, 12], [3, 12], [14, 12], [18, 12], [30, 12], [32, 12], [44, 12], [112, 12], [113, 12], [114, 12], [151, 12], [154, 12], [1, 12], [2, 12], [15, 12], [19, 12], [22, 12], [23, 12], [25, 12], [27, 12], [28, 12], [29, 12], [33, 12], [34, 12], [36, 12], [45, 12], [47, 12], [49, 12], [52, 12], [55, 12], [56, 12], [59, 12], [63, 12], [64, 12], [77, 12], [82, 12], [87, 12], [89, 12], [92, 12], [93, 12], [98, 12], [99, 12], [100, 12], [107, 12], [108, 12], [120, 12], [123, 12], [125, 12], [127, 12], [129, 12], [130, 12], [134, 12], [135, 12], [138, 12], [142, 12], [144, 12], [145, 12], [147, 12], [156, 12], [157, 12], [10, 12], [17, 12], [24, 12], [31, 12], [131, 12], [131, 3], [146, 12], [66, 13], [69, 12], [70, 12], [72, 13], [78, 12], [81, 12], [86, 13], [88, 12], [101, 12], [111, 12], [115, 12], [137, 12], [141, 12], [143, 12], [146, 13], [155, 12], [5, 12], [105, 12], [8, 12], [11, 12], [16, 12], [35, 12], [38, 12], [42, 12], [43, 12], [46, 12], [62, 12], [65, 12], [75, 12], [95, 12], [106, 12], [118, 12], [4, 12], [7, 12], [12, 12], [57, 12], [96, 12], [122, 12], [148, 12], [153, 13], [6, 13], [13, 12], [21, 13], [37, 13], [39, 12], [40, 12], [40, 3], [41, 12], [48, 13], [50, 13], [51, 13], [58, 13], [60, 12], [67, 13], [68, 12], [71, 12], [73, 13], [80, 13], [83, 12], [84, 12], [85, 12], [90, 12], [97, 12], [102, 12], [109, 12], [116, 12], [116, 3], [117, 13], [121, 13], [124, 12], [128, 12], [132, 12], [132, 3], [136, 13], [139, 13], [140, 12], [150, 12], [133, 13], [9, 12], [79, 12], [110, 12], [119, 12], [126, 12], [149, 13], [53, 12], [54, 12], [61, 12], [91, 12], [94, 12], [103, 12], [104, 12], [152, 12], [26, 12]]},
		{name: 'ecopayz', type: 1, pairs: [[20, 12], [20, 3], [3, 12], [14, 12], [18, 12], [30, 12], [32, 12], [44, 12], [112, 12], [113, 12], [114, 12], [151, 12], [154, 12], [1, 12], [2, 12], [15, 12], [19, 12], [22, 12], [23, 12], [25, 12], [27, 12], [28, 12], [29, 12], [33, 12], [34, 12], [36, 12], [45, 12], [47, 12], [49, 12], [52, 12], [55, 12], [56, 12], [59, 12], [63, 12], [64, 12], [77, 12], [82, 12], [87, 12], [89, 12], [92, 12], [93, 12], [98, 12], [99, 12], [100, 12], [107, 12], [108, 12], [120, 12], [123, 12], [125, 12], [127, 12], [129, 12], [130, 12], [134, 12], [135, 12], [138, 12], [142, 12], [144, 12], [145, 12], [147, 12], [156, 12], [157, 12], [10, 12], [17, 12], [24, 12], [31, 12], [131, 12], [131, 3], [146, 12], [66, 13], [69, 12], [70, 12], [72, 13], [74, 12], [78, 12], [81, 12], [86, 13], [88, 12], [101, 12], [111, 12], [115, 12], [137, 12], [141, 12], [143, 12], [146, 13], [155, 12], [5, 12], [105, 12], [8, 12], [11, 12], [16, 12], [35, 12], [38, 12], [42, 12], [43, 12], [46, 12], [62, 12], [65, 12], [75, 12], [95, 12], [106, 12], [118, 12], [4, 12],  [12, 12], [57, 12], [96, 12], [122, 12], [148, 12], [153, 13], [76, 13], [6, 13], [13, 12], [21, 13], [37, 13], [39, 12], [40, 12], [40, 3], [41, 12], [48, 13], [50, 13], [51, 13], [58, 13], [60, 12], [67, 13], [68, 12], [71, 12], [73, 13], [83, 12], [84, 12], [85, 12], [90, 12], [97, 12], [102, 12], [109, 12], [116, 12], [116, 3], [117, 13], [121, 13], [124, 12], [128, 12], [132, 12], [132, 3], [136, 13], [139, 13], [140, 12], [150, 12], [133, 13], [9, 12], [79, 12], [110, 12], [119, 12], [126, 12], [149, 13], [53, 12], [54, 12], [61, 12], [91, 12], [94, 12], [103, 12], [104, 12], [152, 12], [26, 12]]},
		{name: 'zimpler', type: 1, pairs: [[31, 12], [50, 13], [58, 13], [139, 13]]},
		{name: 'alipay', type: 1, pairs: [[50, 13], [58, 13], [139, 13]]},
		{name: 'my-pay-safe-card', type: 1, pairs: [[20, 12], [20, 3], [3, 12], [14, 12], [18, 12], [30, 12], [32, 12], [44, 12], [112, 12], [113, 12], [114, 12], [151, 12], [154, 12], [10, 12], [17, 12], [24, 12], [131, 12], [131, 3], [146, 12], [66, 13], [69, 12], [70, 12], [72, 13], [74, 12], [78, 12], [81, 12], [86, 13], [88, 12], [101, 12], [111, 12], [115, 12], [137, 12], [141, 12], [143, 12], [146, 13], [155, 12], [5, 12], [105, 12], [4, 12], [7, 12], [57, 12], [96, 12], [122, 12], [148, 12], [153, 13], [6, 13], [13, 12], [21, 13], [37, 13], [39, 12], [40, 12], [40, 3], [41, 12], [48, 13], [50, 13], [51, 13], [58, 13], [60, 12], [67, 13], [68, 12], [71, 12], [73, 13], [80, 13], [83, 12], [84, 12], [85, 12], [90, 12], [97, 12], [102, 12], [109, 12], [116, 12], [116, 3], [117, 13], [121, 13], [124, 12], [128, 12], [132, 12], [132, 3], [136, 13], [139, 13], [140, 12], [150, 12], [133, 13], [79, 12], [126, 12], [152, 12], [26, 12]]},
		{name: 'pay-safe-card', type: 2, pairs: [[20, 12], [20, 3], [3, 12], [14, 12], [18, 12], [30, 12], [32, 12], [44, 12], [112, 12], [113, 12], [114, 12], [151, 12], [154, 12], [10, 12], [17, 12], [24, 12], [131, 12], [131, 3], [146, 12], [66, 13], [69, 12], [70, 12], [72, 13], [74, 12], [78, 12], [81, 12], [86, 13], [88, 12], [101, 12], [111, 12], [115, 12], [137, 12], [141, 12], [143, 12], [146, 13], [155, 12], [35, 12], [95, 12], [4, 12], [7, 12], [57, 12], [96, 12], [122, 12], [148, 12], [153, 13], [6, 13], [13, 12], [21, 13], [37, 13], [39, 12], [40, 12], [40, 3], [41, 12], [48, 13], [50, 13], [51, 13], [58, 13], [60, 12], [67, 13], [68, 12], [71, 12], [73, 13], [80, 13], [83, 12], [84, 12], [85, 12], [90, 12], [97, 12], [102, 12], [109, 12], [116, 12], [116, 3], [117, 13], [121, 13], [124, 12], [128, 12], [132, 12], [132, 3], [136, 13], [139, 13], [140, 12], [150, 12], [133, 13], [79, 12], [126, 12], [152, 12], [26, 12]]},
		{name: 'astropay-card', type: 2, pairs: [[20, 12], [20, 3], [3, 12], [32, 12], [151, 12], [154, 12], [6, 13], [58, 13], [102, 12], [136, 13]]},
		{name: 'safetypay-banks', type: 3, pairs: [[20, 12], [20, 3], [30, 12], [32, 12], [6, 13], [13, 12], [58, 13], [102, 12], [136, 13]]},
		{name: 'rapid-transfer', type: 3, pairs: [[6, 13], [41, 12], [50, 13], [67, 13], [73, 13], [109, 12], [117, 13], [139, 13]]},
		{name: 'trustly', type: 3, pairs: [[6, 13], [13, 12], [21, 13], [37, 13], [39, 12], [40, 12], [40, 3], [41, 12], [48, 13], [50, 13], [51, 13], [58, 13], [60, 12], [67, 13], [68, 12], [71, 12], [73, 13], [80, 13], [83, 12], [84, 12], [85, 12], [90, 12], [97, 12], [102, 12], [109, 12], [116, 12], [116, 3], [117, 13], [121, 13], [124, 12], [128, 12], [132, 12], [132, 3], [136, 13], [139, 13], [140, 12], [150, 12], [133, 13]]},
		{name: 'klarna', type: 3, pairs: [[6, 13], [13, 12], [40, 12], [40, 3], [51, 13], [58, 13], [67, 13], [73, 13], [102, 12], [116, 12], [116, 3], [132, 12], [132, 3], [136, 13], [140, 12], [150, 12]]},
		{name: 'poli', type: 3, pairs: [[5, 12], [105, 12]]},
		{name: 'eps', type: 3, pairs: [[6, 13]]},
		{name: 'giropay', type: 3, pairs: [[58, 13]]},
		{name: 'przelewy24', type: 3, pairs: [[116, 12], [116, 3]]},
		{name: 'ideal', type: 3, pairs: [[102, 12]]},
		{name: 'nordea-solo', type: 3, pairs: [[139, 13]]},
		{name: 'entercash', type: 3, pairs: [[6, 13], [58, 13]]},
		{name: 'entercash-finland', type: 3, pairs: [[50, 13]]},
		{name: 'entercash-sweden', type: 3, pairs: [[139, 13]]},
		{name: 'my-bank', type: 3, pairs: [[73, 13]]},
		{name: 'pay-u', type: 3, pairs: [[40, 12], [40, 3], [116, 12], [116, 3]]},
		{name: 'multibanco', type: 3, pairs: [[117, 13]]},
		{name: 'verkkopankki-finnish-online-banking', type: 3, pairs: [[50, 13]]},
		{name: 'trustpay', type: 3, pairs: [[40, 12], [40, 3], [132, 12], [132, 3]]},
		{name: 'enets', type: 3, pairs: [[131, 12]]},
		{name: 'pay-safe-cash', type: 4, pairs: [[6, 13], [21, 13], [37, 13], [50, 13], [67, 13], [73, 13], [80, 13], [117, 13], [121, 13]]},
		{name: 'money-gram', type: 4, pairs: [[118, 12]]},
		{name: 'efecty', type: 4, pairs: [[32, 12], [136, 13], [133, 13]]},
		{name: 'davivienda', type: 4, pairs: [[32, 12]]},
		{name: 'almacense-exito', type: 4, pairs: [[32, 12]]},
		{name: 'banco-de-occidente', type: 4, pairs: [[32, 12]]},
		{name: 'carulla', type: 4, pairs: [[32, 12]]},
		{name: 'edeq', type: 4, pairs: [[32, 12]]},
		{name: 'surtimax', type: 4, pairs: [[32, 12]]},
		{name: 'servipag', type: 4, pairs: [[30, 12]]},
		{name: 'webpay', type: 4, pairs: [[30, 12]]},
		{name: 'pago-facil', type: 4, pairs: [[3, 12]]},
		{name: 'rapi-pago', type: 4, pairs: [[3, 12]]},
		{name: 'red-link', type: 4, pairs: [[3, 12]]},
		{name: 'red-pagos', type: 4, pairs: [[151, 12]]},
		{name: 'oxxo', type: 4, pairs: [[95, 12]]},
		{name: 'bbva-bancomer', type: 4, pairs: [[95, 12]]},
		{name: 'banamex', type: 4, pairs: [[95, 12]]},
		{name: 'santander', type: 4, pairs: [[95, 12]]},
	];
	const industriesGroup = {
		1: [1],
		2: [4],
		3: [5],
		4: [2, 4],
		5: [1, 3, 6, 7],
		6: [2, 3, 6, 7],
		7: [2, 3, 5, 6, 7],
		8: [2, 3, 4, 6, 7],
		9: [2, 3, 4, 5, 6, 7],
		10: [1, 2, 3, 5, 6, 7],
		11: [1, 2, 3, 4, 6, 7],
		12: [3, 6, 7],
		13: [3, 5, 6, 7],
	};

	setListeners();
	updateList(regions, regionsList, regionsNode);

	function setListeners() {
		regionsNode.addEventListener('change', (e) => {
			selectRegion(e.target.selectedOptions[0].value);
		});
		countriesNode.addEventListener('change', (e) => {
			selectCountry(e.target.selectedOptions[0].value);
		});
		industriesNode.addEventListener('change', (e) => {
			selectIndustry(e.target.selectedOptions[0].value);
		});
	}

	function selectRegion(id) {
		selectedRegion = parseInt(id);
		selectedCountryId = parseInt(0);
		selectedIndustry = parseInt(0);
		countriesNode.innerHTML = '<option value="0" class="payment-methods-selects__option" selected disabled>Select country</option>';
		industriesNode.innerHTML = '<option value="0" class="payment-methods-selects__option" selected disabled>Select industries</option>';
		updateList(regionsList[id].countries, countriesList, countriesNode);
		updatePayments();
		switchFormDisplay();
	}

	function selectCountry(id) {
		selectedCountryId = parseInt(id);
		selectedIndustry = parseInt(0);
		industriesNode.innerHTML = '<option value="0" class="payment-methods-selects__option" selected disabled>Select industries</option>';
		updatePayments();
		updateList(countriesList[id].industries, industriesList, industriesNode);
		switchFormDisplay();
	}

	function selectIndustry(id) {
		selectedIndustry = parseInt(id);
		updatePayments();
		renderSelectedCountry(selectedCountryId);
		switchFormDisplay(true);
	}

	function switchFormDisplay(isShow) {
		isShow ? (form.style = "display: block") : (form.style = "display: none");
	}

	function renderSelectedCountry(id) {
		const selectedCountry = d.createElement('h2');
		const icon = d.createElement('i');
		icon.classList.add('flag-icon', `flag-icon-${countriesList[id].ISO2.toLowerCase()}`);
		selectedCountry.classList.add('payment-methods__title');
		selectedCountry.innerHTML = countriesList[id].name;
		selectedCountry.insertAdjacentElement('afterbegin' ,icon);
		paymentsNode.prepend(selectedCountry);
	}

	function isPaymentMethodShow(country, industry, pairs) {
		return pairs.some(pair => pair[0] === country && industriesGroup[pair[1]].includes(industry));
	}

	function updateList(ids, list, domNode) {
		ids.forEach(id => {
			const option = d.createElement('option');
			option.value = id;
			option.classList.add('payment-methods-selects__option');
			option.innerText = list[id].name;
			domNode.appendChild(option);
		});
	}

	function renderPayments(items, type) {
		if (items.length === 0) return;
		const title = d.createElement('h5');
		const row = d.createElement('div');
		row.classList.add('payment-methods__row');
		title.innerText = paymentsTypes[type].name;
		title.classList.add('payment-methods__type');
		paymentsNode.appendChild(row);
		row.appendChild(title);

		items.forEach((item) => {
			const paymentMethod = d.createElement('div');
			paymentMethod.classList.add('payment-methods__name', `payment-methods__name_${item.name}`);
			row.appendChild(paymentMethod);
		})
	}

	function setByType(item, wallet, prepaid, bank, cash) {
		switch (paymentsTypes[item.type].type) {
			case 'wallet':
				wallet.push(item);
				break;
			case 'prepaid':
				prepaid.push(item);
				break;
			case 'bank':
				bank.push(item);
				break;
			case 'cash':
				cash.push(item);
				break;
		}
	}

	function updatePayments() {
		const walletArray = [];
		const prepaidArray = [];
		const bankArray = [];
		const cashArray = [];

		paymentsNode.innerHTML = '';
		paymentsList.forEach((item) => {
			if (isPaymentMethodShow(selectedCountryId, selectedIndustry, item.pairs)) {
				setByType(item, walletArray, prepaidArray, bankArray, cashArray);
			}
		});
		renderPayments(walletArray, 1);
		renderPayments(prepaidArray, 2);
		renderPayments(bankArray, 3);
		renderPayments(cashArray, 4);
	}

}) (window, document);
